import { store } from '../redux/store'
import { open as openContactFormModal } from '../redux/contact-form-modal-slice'

let wrapperEl

document.addEventListener('DOMContentLoaded', () => {
    wrapperEl = document.querySelector('.content-product')
    if (wrapperEl)
    {
        initBannerSolicitePresu()
        initBannersAssociatedServices()
    }
})

function initBannerSolicitePresu ()
{
    const bannerWrapperEl = wrapperEl.querySelector('.banner-solicite-presu')
    if (bannerWrapperEl)
    {
        const bannerEl = bannerWrapperEl.querySelector(':scope > div > *')
        bannerEl.addEventListener('click', (event) => {
            event.stopPropagation()
            const payload = {
                case: 'product',
                product_id: bannerWrapperEl.dataset.productId,
            }
            store.dispatch(openContactFormModal(payload))
        })
    }
}

function initBannersAssociatedServices ()
{
    const bannerEls = wrapperEl.querySelectorAll('.banner-associated-service')
    for (const bannerEl of bannerEls)
    {
        const servicePageLinkEl = bannerEl.querySelector('.service-page-link')

        bannerEl.addEventListener('click', (event) => {
            event.stopPropagation()
            const payload = {
                case: bannerEl.dataset.genpageSpecialRolRef,
            }
            store.dispatch(openContactFormModal(payload))
        })

        /* Prevent opening form when clicking on the link */
        servicePageLinkEl.addEventListener('click', (event) => {
            event.stopPropagation()
        })
    }
}
